import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  standalone: false,
    selector: 'table-row-wrapper',
    templateUrl: './table-row.component.html',
})
export class TableRowWrapperComponent extends FieldWrapper {
}
